import classNames from 'classnames';

import React, {
  forwardRef,
  ForwardRefExoticComponent,
  HTMLAttributes,
  RefAttributes,
  useEffect,
} from 'react';

import styles from './header.scss';

type HeaderProps = RefAttributes<HTMLDivElement> &
  HTMLAttributes<
    HTMLDivElement & {
      dataTestId?: string;
    }
  >;

const COMPONENT_ID = 'modulor-header';

export const Header: ForwardRefExoticComponent<HeaderProps> = forwardRef<
  HTMLDivElement,
  HeaderProps
>(({ style, children, className, ...rest }, ref, dataTestId = COMPONENT_ID) => {
  useEffect(() => {
    console.warn('Modulor: Header component is deprecated. Use Header2 instead.');
  }, []);

  return (
    <div
      className={classNames(className, styles.container)}
      ref={ref}
      {...rest}
      data-testid={dataTestId}
      data-id={dataTestId}
      data-component-name={COMPONENT_ID}>
      <div style={style} className={styles.header}>
        {children}
      </div>
    </div>
  );
});

Header.displayName = 'Header';
